import React, { createContext, useContext, useEffect, useReducer } from "react";
import { NotebookReducer } from "./reducer";
import { MODIFY_RUNNING_CODE_OUTPUT, MODIFY_CELL_EXECUTION_DETAILS } from "./reducer";
export const WorkflowContext = createContext({});
export const useWorkflowContext = () => {
    return useContext(WorkflowContext);
}

export const WorkflowProvider = ({ children, initialData }) => {
    const initialiseState = (initialData) => {
        if (!initialData.code || !initialData.metadata) return {}
        return {
            notebook: initialData.code,
            metadata: initialData.metadata,
            steps: initialData.metadata?.steps,
            cwc: initialData?.code?.cells?.map(cell => {
                if (cell.cell_type === "code") {
                    return {
                        "isLoading": false,
                        "context": cell['source'].join(''),
                        "chat": [{ type: "outgoing", isCode: true, message: cell['source'].join('') }],
                        "debug": [{ type: "outgoing", isCode: true, message: cell['source'].join('') }],
                    };
                }
                // Return other types of cells if needed
                return {
                    "isLoading": false,
                    "context": "",
                    "chat": [{ type: "outgoing", isCode: false, message: "" }],
                    "debug": [{ type: "outgoing", isCode: false, message: "" }]
                };
            }),
            cellExecutionDetails: initialData.code?.cells?.map(() => {
                return { isExecuting: false, startTime: null, executionCount: 0 };
            }),
        }
    }
    const tempstate = initialiseState(initialData);
    const [state, dispatch] = useReducer(NotebookReducer, tempstate);
    React.useEffect(() => {
        console.log("refreshing")
        dispatch({ type: 'UPDATE_STATE', payload: initialiseState(initialData) });
    }, [initialData]);

    // write code for run cell
    const [RunCodequeue, setRunCodequeue] = React.useState([]);
    const [processing, setProcessing] = React.useState(false);
    const [executionCount, setExecutionCount] = React.useState(1);
    const setResponseData = (cellIndex, output) => {
        let out = [...output];
        dispatch({ type: MODIFY_RUNNING_CODE_OUTPUT, payload: { cellIndex: cellIndex, output: out } });

    }
    const RunCodeCells = async (cellIndex, code) => {
        dispatch({ type: MODIFY_CELL_EXECUTION_DETAILS, payload: { cellIndex: cellIndex, isExecuting: "true" } });
        addToQueue({ cellIndex: cellIndex, code: code });
    }
    const RunCodeCell = async (cellIndex, code, countflag) => {
        try {
            // let flagToInterruptStream = false;
            const output = [];
            setResponseData(cellIndex, output);
            // API call
            const response = await fetch('https://workable-ai-ml-2.onrender.com/run-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: code,
                    host: '74.80.190.17',
                    username: 'sabhay',
                    secret: 'abcdefgh567635@#%!&',
                    "port": 8000
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let partialChunk = '';
            while (true) {
                const { value, done } = await reader.read();
                if (done) {
                    console.log("done")
                    break;
                }
                let decodedChunk = decoder.decode(value, { stream: true });
                let decodedChunkArray = (partialChunk + decodedChunk).split("\n"); // Split by newline characters
                partialChunk = decodedChunkArray.pop(); // Keep the last chunk if it's incomplete JSON
                let decodedChunkJson = {}
                try {
                    for (let i = 0; i < decodedChunkArray.length; i++) {
                        if (decodedChunkArray[i] === "") continue;
                        decodedChunkJson = JSON.parse(JSON.parse(decodedChunkArray[i]));
                        // console.log(decodedChunkJson);
                        if (decodedChunkJson["type"] === "text/plain") {
                            if (decodedChunkJson["name"] === "stderr") {
                                const len = output.length;
                                if (len > 0 && "name" in output[len - 1] && output[len - 1].name === "stderr") {
                                    output.pop();
                                }
                            }
                            output.push({
                                "name": decodedChunkJson["name"],
                                "output_type": "stream",
                                "text": [decodedChunkJson['data']]
                            })
                        }
                        else if (decodedChunkJson["type"] === "traceback") {
                            output.push({
                                "ename": "SyntaxError",
                                "evalue": "invalid syntax (<ipython-input-1-eea3320642ac>, line 1)",
                                "output_type": "error",
                                "traceback": [decodedChunkJson['data']]
                            })
                        }
                        else if (decodedChunkJson["type"] === "image/png") {
                            output.push({
                                "data": {
                                    "image/png": decodedChunkJson['data'],
                                    "text/plain": [
                                        ""
                                    ]
                                },
                                "metadata": {},
                                "output_type": "display_data"
                            },)
                        }
                        else if (decodedChunkJson["type"] === "text/html") {
                            let tempdata = decodedChunkJson['data'].split("\n").map((line, index, array) => index === array.length - 1 ? line : line + '\n')
                            tempdata = tempdata.filter(item => !item.includes("  \n"));
                            output.push({
                                "data": {
                                    "text/html": tempdata,
                                    "text/plain": [
                                        ""
                                    ]
                                },
                                "metadata": {},
                                "output_type": "display_data",
                            })
                        }
                        else {
                            output.push({
                                "name": "stderr",
                                "output_type": "stream",
                                "text": [decodedChunkJson]
                            })
                        }
                    }
                    setResponseData(cellIndex, output);
                } catch (error) {
                    console.log("JSON parse error")
                    console.log(error)
                    output.push({
                        "name": "stderr",
                        "output_type": "stream",
                        "text": ["Internal Server Error"]
                    })
                    setResponseData(cellIndex, output);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            dispatch({ type: MODIFY_CELL_EXECUTION_DETAILS, payload: { cellIndex: cellIndex, isExecuting: "false", executionCount: countflag } })
        }

    }
    // Function to add a request to the queue
    const addToQueue = (request) => {
        setRunCodequeue(prevQueue => [...prevQueue, request]);
    };
    // Function to process the queue
    const processQueue = async () => {
        if (RunCodequeue.length > 0 && !processing) {
            setProcessing(true);
            const nextRequest = RunCodequeue[0];
            try {
                await RunCodeCell(nextRequest.cellIndex, nextRequest.code, executionCount);
                setExecutionCount(prev => {
                    return prev + 1;
                })
            } catch (error) {
                console.error('Error processing request:', error);
            } finally {
                setProcessing(false);
                setRunCodequeue(prevQueue => prevQueue.slice(1)); // Remove the processed request from the queue
            }
        }
    };
    // Effect to automatically process the queue whenever it changes
    useEffect(() => {
        processQueue();
    }, [RunCodequeue]);
    const InterruptCodeExecution = async () => {
        try {
            const response = await fetch('https://workable-ai-ml-2.onrender.com/interrupt', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    host: '74.80.190.17',
                    username: 'sabhay',
                    secret: 'abcdefgh567635@#%!&',
                    "port": 8000
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch');
            }
            console.log("Interrupted Code Execution");
        } catch (error) {
            console.log("Error occured in Interrupt Code Execution");
            console.log(error);
        }
        finally {
            dispatch({ type: MODIFY_CELL_EXECUTION_DETAILS, payload: { stopAllCells: true } })
            // setCellExecutionDetails(prevDetails => {
            //     const tempDetails = prevDetails.map(cellDetail => {
            //         return {
            //             ...cellDetail,
            //             isExecuting: false
            //         };
            //     });
            //     return tempDetails;
            // });
            // controller1.abort();
        }

    }

    const StopCodeExecution = () => {
        setRunCodequeue([]);
        InterruptCodeExecution();
    };

    // **********************************************************
    const value = {
        state,
        dispatch,
        RunCodeCells,
        StopCodeExecution,
    };
    return (
        <WorkflowContext.Provider value={value}>
            {children}
        </WorkflowContext.Provider>
    )
}

export default WorkflowProvider;